import { render, staticRenderFns } from "./OrderTotalsRow.vue?vue&type=template&id=4b348302&scoped=true&"
import script from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
export * from "./OrderTotalsRow.vue?vue&type=script&lang=js&"
import style0 from "./OrderTotalsRow.vue?vue&type=style&index=0&id=4b348302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b348302",
  null
  
)

export default component.exports